// extracted by mini-css-extract-plugin
export default {"wrapper":"EmailInput_wrapper__wKzC9"};